export const parseFlightObjects = (flights) => {
  const parseFlightOption = (flightOption, flightOffer) => ({
    ...flightOption,
    AlternativeCurrencyPricingDetails:
      flightOffer.AlternativeCurrencyPricingDetails,
    FlightPassengerPrices: flightOffer.FlightPassengerPrices,
    FlightPrice: flightOffer.FlightPrice,
    PricingDetails: flightOffer.PricingDetails,
    Reference: flightOption.Reference.$t,
    FlightSegments: flightOption.FlightSegments.FlightSegment.map(
      (segment) => segment
    ),
  });

  const FlightObj = flights.map((flight) => {
    return {
      flightOffer: flight,
      oneWay: flight.FlightItinerary.FlightStream[0].FlightOption[0],
      returnWay:
        flight.FlightItinerary.FlightStream[1] !== undefined
          ? flight.FlightItinerary.FlightStream[1].FlightOption[0]
          : null,
    };
  });
  const FlightSegments = FlightObj.map((flight) => {
    if (flight.returnWay === null)
      return {
        oneWay: parseFlightOption(flight.oneWay, flight.flightOffer),
      };

    return {
      oneWay: parseFlightOption(flight.oneWay, flight.flightOffer),
      returnWay: parseFlightOption(flight.returnWay, flight.flightOffer),
    };
  });
  return FlightSegments;
};

export const parseCodebookObject = (codebook) => {
  const Airplanes = codebook.Airplanes.Airplane.map((airplane) => ({
    Type: airplane.Type,
    Name: airplane.$t,
  }));
  const Airports = codebook.Airports.Airport.map((airport) => {
    const newAirport = { ...airport, Name: airport.$t };
    delete newAirport.$t;
    return newAirport;
  });

  const TransportCompanies = codebook.TransportCompanies.TransportCompany.map(
    (tcompany) => {
      return {
        ...tcompany,
        LogoUrl: tcompany.LogoUrl.$t,
        Name: tcompany.Name.$t,
      };
    }
  );
  return {
    Airports: [...Airports],
    Airplanes: [...Airplanes],
    TransportCompanies: [...TransportCompanies],
  };
};
